(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssd-premium-engraving-page"] && !Shopify.designMode) return;
  try {
    function openEngravingGroup() {
  const id = decodeURIComponent(window.location.hash.slice(1));
  const target = document.getElementById(id);
  if (!target || !target.closest('.ssd-engraving-page')) return;
  let group = target.matches('details') ? target : target.closest('details');
  while (group && group.closest('.ssd-engraving-page')) {
    group.open = true;
    group = group.parentElement.closest('details');
  }
  target.scrollIntoView({block: 'start'});
}
window.addEventListener('hashchange', openEngravingGroup);
document.addEventListener('DOMContentLoaded', openEngravingGroup);
openEngravingGroup();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ssd-public-navigation"] && !Shopify.designMode) return;
  try {
    function initializeInstrumentNavigation(){
  document.querySelectorAll('.ssd-desktop-nav .ssd-instruments-menu').forEach(menu=>{
    if(menu.dataset.bound)return;
    menu.dataset.bound='true';
    const groups=menu.querySelectorAll('.ssd-instrument-group');
    let timer;
    const open=()=>{clearTimeout(timer);menu.open=true;groups.forEach(group=>{group.open=true;});};
    const close=()=>{menu.open=false;};
    menu.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')open();});
    menu.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')timer=setTimeout(()=>{if(!menu.contains(document.activeElement))close();},200);});
    menu.addEventListener('toggle',()=>{if(menu.open)groups.forEach(group=>{group.open=true;});});
    menu.addEventListener('focusout',()=>{setTimeout(()=>{if(!menu.contains(document.activeElement)&&!menu.matches(':hover'))close();},0);});
  });
}
document.addEventListener('DOMContentLoaded',initializeInstrumentNavigation);
document.addEventListener('shopify:section:load',initializeInstrumentNavigation);
document.addEventListener('click',event=>{
  document.querySelectorAll('.ssd-instruments-menu[open],.ssd-mobile-nav[open]').forEach(menu=>{
    if(!menu.contains(event.target))menu.open=false;
  });
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('.ssd-instruments-menu[open],.ssd-mobile-nav[open]').forEach(menu=>{
    if(menu.contains(document.activeElement))menu.querySelector('summary').focus();
    menu.open=false;
  });
});
initializeInstrumentNavigation();
  } catch(e) { console.error(e); }
})();

})();
